import useBusinessNavigate, { getBusinessUrl } from '~/lib/useBusinessNavigate';
import Loading from '~/components/Loading';
import React, { useRef, useState } from 'react';
import { setPackagesQuery, usePackagesQuery } from '~/lib/Queries';
import { PackageTypes } from '~/lib/PackageHelpers';
import { Link } from 'react-router-dom';
import PageHeading from '~/components/PageHeading';
import FeatureIntro from '~/components/FeatureIntro';
import SectionPicker from '~/components/SectionPicker';
import AllPackageGrants from '~/components/packages/AllPackageGrants';
import { ucfirst } from '~/lib/Utils';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import SortableList from '~/components/SortableList';

const PackageRow = ({ thisPackage, isFirst, editPathBase }) => {
    const navigate = useBusinessNavigate();

    return (
        <div
            className={`py-4 pr-6 ${!isFirst ? 'border-t' : ''} flex items-center justify-between`}
        >
            <div
                className="flex-1 cursor-pointer"
                onClick={() => navigate(`${editPathBase}/${thisPackage.id}`)}
            >
                {thisPackage.name}
            </div>
        </div>
    );
};

const PackagesList = ({ packages, isLoading, plural, editPathBase, type }) => {
    const { data } = usePackagesQuery(type);
    const { save: saveOrder, isSaving: isSavingOrder } = useBusinessPostApi(
        `/packages/reorder?type=${type}`,
    );

    function onReorder(newItems) {
        saveOrder({
            order: newItems.map(p => p.id),
        });
        setPackagesQuery(
            {
                ...data,
                packages: newItems,
            },
            type,
        );
    }

    return (
        <div className="panel pl-6">
            {isLoading && <Loading className="p-4" />}
            {packages.length === 0 && !isLoading && (
                <div className="pt-4 pr-4 pb-4 text-gray-500">There are no {plural}</div>
            )}
            <SortableList
                items={packages}
                renderItem={({ item }) => (
                    <PackageRow
                        thisPackage={item}
                        key={item.id}
                        isFirst={true}
                        editPathBase={editPathBase}
                    />
                )}
                onReorder={onReorder}
                containerClassName={'divide-y'}
            />
            {/*{packages.map((p, idx) => (*/}
            {/*    <PackageRow*/}
            {/*        thisPackage={p}*/}
            {/*        key={p.id}*/}
            {/*        isFirst={idx === 0}*/}
            {/*        editPathBase={editPathBase}*/}
            {/*    />*/}
            {/*))}*/}
        </div>
    );
};

const PackagePageTemplate = ({
    type,
    singular,
    plural,
    introText,
    editPathBase,
}) => {
    const [section, setSection] = useState('list');
    const grantListRef = useRef();
    const navigate = useBusinessNavigate();
    const { data, isLoading } = usePackagesQuery(type);
    const packages = data?.packages || [];

    return (
        <div>
            <PageHeading
                heading={ucfirst(plural)}
                rightContent={
                    <button
                        type="button"
                        className={`btn-pill ${section === 'list' ? 'opacity-1' : 'opacity-0 hidden'}`}
                        onClick={() => navigate(`${editPathBase}/0`)}
                    >
                        Add {ucfirst(singular)}
                    </button>
                }
            />

            <FeatureIntro>{introText}</FeatureIntro>

            <div className="flex flex-wrap items-center justify-between max-w-4xl">
                <SectionPicker
                    className="mb-4"
                    value={section}
                    onChange={setSection}
                    options={[
                        { value: 'list', label: plural },
                        { value: 'clients', label: 'Clients' },
                    ]}
                />
                {section === 'clients' && packages?.length > 0 && (
                    <button
                        type="button"
                        className="btn-light-pill mb-4 w-full xs:w-auto"
                        onClick={() => grantListRef.current?.showNewGrant()}
                    >
                        Add {ucfirst(singular)} to Client
                    </button>
                )}
            </div>

            {section === 'list' && (
                <PackagesList
                    packages={packages}
                    isLoading={isLoading}
                    plural={plural}
                    editPathBase={editPathBase}
                    type={type}
                />
            )}

            {section === 'clients' && (
                <AllPackageGrants
                    ref={grantListRef}
                    packages={packages}
                    type={type}
                    singular={singular}
                    plural={plural}
                />
            )}
        </div>
    );
};

export default PackagePageTemplate;
